import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const Lte = ({ property, filter, onChange }) => {
  const PropertyComponent = resolveComponentForOperator(property.type, 'LTE')

  return (
    <div>
      <PropertyComponent
        property={property}
        filter={filter}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default Lte
